<template>
  <div>
    <webshipper-input-label
      :label="label"
      :value="value"
      :default_value="default_value"
      @revert="update_value($event)"
    ></webshipper-input-label>
    <div class="d-flex flex-wrap button-wrapper">
      <button
        class="btn btn-lg m-2 flex-grow-1"
        v-for="option in options"
        type="button"
        :class="{ 'btn-primary': value_model === option, 'btn-outline-secondary': value_model !== option }"
        @click="update(option)"
      >
        {{ option | t }}
      </button>
    </div>
    <webshipper-input-revert
      v-if="!readonly"
      :value="value"
      :default_value="default_value"
      @revert="update_value($event)"
    ></webshipper-input-revert>
  </div>
</template>
<script>
import languages from '@cospired/i18n-iso-languages';
import _ from 'lodash';

languages.registerLocale(require('@cospired/i18n-iso-languages/langs/en.json'));
export default {
  props: {
    options: {
      type: Array | null,
      required: true
    },
    value: {
      type: Boolean | String | null,
      required: true
    },
    default_value: {
      type: Boolean | String | null,
      required: false,
      default: null
    },
    select_first_when_empty_model: {
      type: Boolean,
      required: false,
      default: true
    },
    has_revert: {
      type: Boolean,
      required: false,
      default: true
    },
    label: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    value_model: {
      get() {
        if (this.value !== null && this.value !== '') {
          return this.value;
        }

        if (this.default_value !== null) {
          return this.default_value;
        }

        if (this.select_first_when_empty_model && this.options.length > 0) {
          this.$emit('input', this.options[0]);
          return this.options[0];
        }

        return null;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    revert(event) {
      this.$emit('input', event);
    },
    update(value) {
      if (this.value_model === value) {
        return;
      }
      this.$emit('input', value);
    }
  }
};
</script>

<style scoped>
.button-wrapper {
  margin: -.5rem;
}
</style>
